module.exports = __webpack_public_path__ + "img/game-scheduled-game.9f3bb3cc.png";